import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { DetailComponent } from './detail/detail.component';
import { ListComponent } from './list/list.component';
import { PatientDetailsGuard } from '../core/guards/patient-details.guard';

const routes: Routes = [
  {
    path: '',
    component: ListComponent,
  },
  {
    path: 'detail/:uuid',
    component: DetailComponent,
    canActivate: [PatientDetailsGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PatientsRoutingModule {}
